import * as actionTypes from "./actionTypes";

export const getAllList = (allList, totalList) => {
  return {
    type: actionTypes.GET_ALL_LIST,
    timelineTodoList: allList,
    total: totalList,
  };
};

export const createList = (singleList) => {
  return {
    type: actionTypes.CREATE_LIST,
    list: singleList,
  };
};

export const updateList = (singleList) => {
  return {
    type: actionTypes.UPDATE_LIST,
    list: singleList,
  };
};

export const setListLoader = (loaderValue) => {
  return {
    type: actionTypes.SET_LIST_LOADER,
    loaderValue: loaderValue,
  };
};

export const listPageIncreament = () => {
  return {
    type: actionTypes.LIST_PAGE_INCREAMENT,
  };
};

export const clearAllList = () => {
  return {
    type: actionTypes.CLEAR_ALL_LIST,
  };
};
